// SVG
import mmusicLogoWhiteText from "./images/mmusic-logo-white-text.svg";
import mkaraokeLogoWhiteText from "./images/mkaraoke-logo-white-text.svg";
import mmusicLogoWhiteSmall from "./images/mmusic-logo-white-small.svg";
import mkaraokeLogoWhiteSmall from "./icons/mkaraoke-logo-white-small.svg";
import mmusicLogoBorderedBlue from "./icons/mmusic-logo-bordered.svg";
import sidebarArrow from "./icons/sidebar-arrow.svg";
import sidebarStatistic from "./icons/sidebar-statistic.svg";
import sidebarWallet from "./icons/sidebar-wallet.svg";
import sidebarNote from "./icons/sidebar-note.svg";
import sidebarProfile from "./icons/sidebar-profile.svg";
import sidebarLogout from "./icons/sidebar-logout.svg";
import documentMMusic from "./images/Documents-from-MMusic.png";
import signatureTulgaa from "./images/signature-from-MMusic.png.png";
import mmusicLogo from "./images/mmusic-logo-full.svg";
import CardIcon1 from "./icons/creation-card-1.svg";
import CardIcon2 from "./icons/creation-card-2.svg";
import CardIcon3 from "./icons/creation-card-3.svg";
import CardIcon4 from "./icons/creation-card-4.svg";
import CardIcon5 from "./icons/creation-card-5.svg";
import CardIcon6 from "./icons/creation-card-6.svg";
import callIcon from "./icons/call-icon.svg";
import addImage from "./icons/add-Image.svg";
import shuffle from "./icons/shuffle.svg";
import close from "./icons/close-icon.svg";
// bank icons
import KhanBank from "./icons/khanbank.svg";
import XasBank from "./icons/xasbank.svg";
import TDB from "./icons/tdb.svg";
import NationalBank from "./icons/nationalbank.svg";
import CapitronBank from "./icons/capitronbank.svg";
import BogdBank from "./icons/bodgbank.svg";
import StateBank from "./icons/statebank.svg";
import MostMoney from "./icons/mostmoney.svg";
import writingIcon from "./icons/writing-icon.svg";
import CreationSort from "./icons/creation-sort.svg";
import ChevronDown from "./icons/chevron-down.svg";
import ChevronLeftBlue from "./icons/chevron-left-blue.svg";
import ChevronRightBlue from "./icons/chevron-right-blue.svg";
import walletTrendingUp from "./icons/wallet-trending-up.svg";
import walletTrendingDown from "./icons/wallet-trending-down.svg";
import walletBalance from "./icons/wallet-balance.svg";
import DocumentDownload from "./icons/document-download.svg";
import passwordEye from "./icons/password-eye.svg";
import passwordEyeOff from "./icons/password-eye-off.svg";
import infoIcon from "./icons/login-popup-info.svg";
import warningIcon from "./icons/login-popup-warning.svg";
import successIcon from "./icons/login-popup-success.svg";
import popupClose from "./icons/login-popup-x.svg";
import passwordChange from "./icons/password-change.svg";
import pdfPrevSkip from "./icons/pdf-prev-skip.svg";
import pdfPrevOne from "./icons/pdf-prev-one.svg";
import pdfNextSkip from "./icons/pdf-next-skip.svg";
import pdfNextOne from "./icons/pdf-next-one.svg";
import pdfZoomOut from "./icons/pdf-zoom-out.svg";
import pdfZoomIn from "./icons/pdf-zoom-in.svg";
import pdfChevronDown from "./icons/pdf-chevron-down.svg";
import editIcon from "./icons/artistImage-pencil.svg";
import editPen from "./icons/edit-pen.svg";
import saveIcon from "./icons/account-info-save.svg";
import ellipse1 from "./icons/ellipse-1.svg";
import ellipse2 from "./icons/ellipse-2.svg";
import ellipse3 from "./icons/ellipse-3.svg";
import cancelIcon from "./icons/information-cancel.svg";
import chevronDownBlue from "./icons/chevron-down-blue.svg";
import genreCrown from "./icons/genre-crown-active.svg";
import genreCrownWhite from "./icons/main-genre-crown-white.svg";
import requestMail from "./icons/request-mail.svg";
import chevronDown from "./icons/artist-chevron-down.svg";
import chevronRight from "./icons/select-chevron-right.svg";
import organization from "./icons/organization.svg";
import nationalIdIcon from "./icons/National-iD-icon.svg";
import fileEdit from "./icons/file-edit.svg";
import fileEditWhite from "./icons/file-edit-white.svg";
import arrowRight from "./icons/arrow-right.svg";
import rightArrow from "./icons/right-arrow.svg";
import arrowRightWhite from "./icons/arrow-right-white.svg";
import warning from "./icons/warning-icon.svg";

// ashiglaagui SVG
import cardTrendingUp from "./icons/wallet-trending-up.svg";
import cardTrendingDown from "./icons/wallet-trending-down.svg";
import MkaraokeLogo from "./images/mkaraoke.png";
import MmusicLogo from "./images/mmusic.png";
import mmusicCover from "./images/mmusic-cover.png";
import mkaraokeCover from "./images/mkaraoke-cover.png";
import mmusicBackground from "./images/mkaraoke-background.png";
import mkaraokeBackground from "./images/mmusic-background.png";
// ashiglaagui SVG
import genreKill from "./icons/genre-kill.svg";
import checkboxChecked from "./icons/check-box-checked.svg";
import crownActive from "./icons/genre-crown-active.svg";
import crownInactive from "./icons/genre-crown-inactive.svg";
import informationCancel from "./icons/information-cancel.svg";
import informationSave from "./icons/information-save.svg";
import artistImageCamera from "./icons/artistImage-camera.svg";
import switchIcon from "./icons/sidebar-switch.svg";
import searchIcon from "./icons/search-icon.svg";
import calendar from "./icons/select-calendar.svg";
import prevMonth from "./icons/calendar-prev-month.svg";
import nextMonth from "./icons/calendar-next-month.svg";
import calendarClear from "./icons/calendar-clear.svg";
import listenedDecor from "./icons/most-listened-decor.svg";
import downloadedDecor from "./icons/most-downloaded-decor.svg";
import likedDecor from "./icons/most-liked-decor.svg";
import selectedPublisher from "./icons/selected-publisher.svg";
import notFound404 from "./images/404.png";
import notFound from "./images/404_fill.png";
import cornerBG from "./images/Corner.png";
import MetaIcon from "./images/meta.png";
import MetaColorIcon from "./images/meta-color.png";
// IMG
import loadingLottie from "./lotties/loader.json";

// LOTTIE
const assets = {
  svg: {
    mmusicLogoWhiteText,
    mkaraokeLogoWhiteText,
    mmusicLogoWhiteSmall,
    mkaraokeLogoWhiteSmall,
    sidebarArrow,
    sidebarStatistic,
    sidebarWallet,
    sidebarNote,
    sidebarProfile,
    sidebarLogout,
    mmusicLogo,
    CardIcon1,
    CardIcon2,
    CardIcon3,
    CardIcon4,
    CardIcon5,
    CardIcon6,
    CreationSort,
    ChevronDown,
    ChevronLeftBlue,
    ChevronRightBlue,
    walletTrendingUp,
    walletTrendingDown,
    walletBalance,
    DocumentDownload,
    passwordEye,
    passwordEyeOff,
    infoIcon,
    arrowRight,
    warningIcon,
    successIcon,
    popupClose,
    close,
    passwordChange,
    pdfPrevSkip,
    pdfPrevOne,
    pdfNextSkip,
    pdfNextOne,
    pdfZoomOut,
    pdfZoomIn,
    pdfChevronDown,
    editIcon,
    editPen,
    saveIcon,
    ellipse1,
    ellipse2,
    ellipse3,
    cancelIcon,
    chevronDownBlue,
    genreCrown,
    genreCrownWhite,
    requestMail,
    chevronDown,
    genreKill,
    checkboxChecked,
    crownActive,
    crownInactive,
    informationCancel,
    informationSave,
    artistImageCamera,
    nationalIdIcon,
    fileEdit,
    fileEditWhite,
    switchIcon,
    chevronRight,
    searchIcon,
    calendar,
    shuffle,
    prevMonth,
    nextMonth,
    calendarClear,
    callIcon,
    addImage,
    writingIcon,
    rightArrow,
    arrowRightWhite,
    warning,
    organization,
    cardTrendingUp,
    cardTrendingDown,
    listenedDecor,
    downloadedDecor,
    likedDecor,
    selectedPublisher,
    mmusicLogoBorderedBlue,
    TDB,
    KhanBank,
    XasBank,
    StateBank,
    MostMoney,
    CapitronBank,
    NationalBank,
    BogdBank,
  },
  image: {
    notFound404,
    notFound,
    cornerBG,
    MmusicLogo,
    MkaraokeLogo,
    mkaraokeCover,
    mmusicCover,
    mmusicBackground,
    mkaraokeBackground,
    documentMMusic,
    signatureTulgaa,
    MetaIcon,
    MetaColorIcon,
  },
  lottie: {
    loadingLottie,
  },
};

export default assets;
